import { mapState } from 'vuex';

import notifications from "@/components/modules/notifications/index.vue";
import homeAdd from "@/components/modules/app/home/add/index.vue";

export default {
	name: 'home',
	props: {
	},

	components : {
		notifications,
		homeAdd
	},

	data : function(){

		return {
			loading : false,
			last : null
		}

	},

	created () {
	},

	watch: {
		//$route: 'getdata'
	},
	computed: mapState({
		auth : state => state.auth,
        mobileview : state => state.mobileview,

		features : function(state){
			return state.features
		},
		
	}),

	methods : {
		
	},
}